import axiosClient from "../axiosClient";

export const apiGetServiceIssues = () =>
  axiosClient.get("/service-issues/");

export const apiCreateServiceIssue = (payload) =>
  axiosClient.post("/service-issues/", payload);

export const apiAssignServiceIssue = (ticketId, payload) =>
  axiosClient.post(`/service-issues/${ticketId}/assign/`, payload);

export const apiScheduleServiceIssue = (ticketId, payload) =>
  axiosClient.post(`/service-issues/${ticketId}/schedule/`, payload);

// optional (only if backend supports GET by id)
export const apiGetServiceIssueById = (ticketId) =>
  axiosClient.get(`/service-issues/${ticketId}/`);